export default {
      id: "arrow-left-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 123
// module chunks = 241 242 243